import requestAction from '../../utils/requestAction'

export const fetchPrepayment = (prepaymentId: string, clientId?: string, params?: string, handleResponse?: (response: any) => void) =>
  requestAction('PREPAYMENT_DETAIL', params)(`prepayments/detail?prepaymentId=${prepaymentId}${clientId ? '&clientId=' + clientId : ''}`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })

export const fetchPrepaymentDiscounts = (prepaymentId: string, clientId?: string, params?: string, handleResponse?: (response: any) => void) =>
  requestAction('PREPAYMENT_DISCOUNTS', params)(`prepayments/detailDiscounts?prepaymentId=${prepaymentId}${clientId ? '&clientId=' + clientId : ''}`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })
